var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconInvoice = function SvgIconInvoice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1667 5.33333H5.33333H4.5C4.04083 5.33333 3.66667 4.95917 3.66667 4.5C3.66667 4.04083 4.04083 3.66667 4.5 3.66667H17V4.5H18.6667V2.83333C18.6667 2.37333 18.2933 2 17.8333 2H4.5C3.11917 2 2 3.11917 2 4.5V18.6667C2 20.5075 3.4925 22 5.33333 22H21.1667C21.6267 22 22 21.6267 22 21.1667V6.16667C22 5.70667 21.6267 5.33333 21.1667 5.33333ZM17 15.3333C16.0792 15.3333 15.3333 14.5875 15.3333 13.6667C15.3333 12.7458 16.0792 12 17 12C17.9208 12 18.6667 12.7458 18.6667 13.6667C18.6667 14.5875 17.9208 15.3333 17 15.3333Z",
    fill: "#A9ADBB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInvoice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconInvoice.e9f94b4b.svg";
export { ForwardRef as ReactComponent };